import React from 'react';

const Loading = ({ h }) => {
  return (
    <div
      className="col-center"
      style={{
        position: 'relative',
        height: h,
      }}
    >
      <Spinner color="var(--ultrablack" />
    </div>
  );
};

const Spinner = ({ color, transforms = null }) => {
  return (
    <div
      style={{
        position: 'relative',
        display: ' inline-block',
        width: '4rem',
        height: '4rem',
        overflow: 'hidden',
        textIndent: '-999em',
        verticalAlign: 'text-bottom',
        backgroundColor: color,
        borderRadius: '50%',
        animationName: 'spinner',
        animationDuration: ' .75s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        transform: transforms ? transforms : null,
      }}
    />
  );
};

export default Loading;
